namespace $ {

	export const $bog_max_status = {
		new: 'Зарегистрирована',
		accepted: 'Принята, назначен исполнитель',
		work: 'В работе',
		done: 'Выполнена',
		rejected: 'Отклонена',
	} as const

}
